import AuthMenuPanel from "components/common/AuthMenuPanel";
import AuthUserBox from "components/common/AuthUserBox";
import React from "react";

const ActivitiesLandingLeftPanel = () => {
  return (
    <div className="pnl_leftpnl hidden_mobile">
      <AuthUserBox />
      <AuthMenuPanel moduleName="activity" />
    </div>
  );
};

export default ActivitiesLandingLeftPanel;
